<template>
  <div class="body_right">
    <div class="right_container">
      <div class="right_title">
        <div class="title">상세 출입 설정</div>
        <div class="description">
          · 예약 시작시간 전후로 출입 허용 시간을 설정할 수 있습니다. <br />
          · 페이지 하단 ‘허용 설정 추가’를 클릭하면, 사업장 별로 허용시간을
          다르게 설정할 수 있습니다.
        </div>
        <article class="right_body">
          <div
            v-for="(setting, index) in settings"
            :key="setting.id"
            class="tbl_search tbl_info"
            v-show="!isAnyAllLocationsChecked || setting.allLocations"
          >
            <div class="part_title between">
              <span>허용설정 {{ index + 1 }}</span>
              <!-- <button v-if="settings.length > 1" @click="removeSetting(index)"> -->
              <button v-if="index > 0" @click="removeSetting(index)">
                삭제
              </button>
            </div>
            <table>
              <colgroup>
                <col style="width: 20%" class="col_width26" />
                <col />
              </colgroup>
              <tr style="display: none">
                <th>입실 가능 출입허용</th>
                <td class="inner_td">
                  <div>
                    <input
                      type="checkbox"
                      :id="'toggle' + setting.id"
                      class="toggle"
                      hidden
                      v-model="setting.inTimeApprovalYN"
                    />
                    <label :for="'toggle' + setting.id" class="toggleSwitch">
                      <span class="toggleButton"></span>
                    </label>
                  </div>
                </td>
              </tr>
              <tr style="display: none">
                <th>예약 가능 허용시간 설정</th>
                <td>
                  <div class="inner_td">
                    <input
                      type="number"
                      class="w_55"
                      v-model="setting.resAvailableTime"
                      @input="checkNegative_res(setting)"
                    />분
                    <div class="validation text_green">
                      ※ 예약이 비었을 경우, 시작 시간 이후 최대 10분까지 예약을
                      허용합니다.
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>예약 시작시간 이전</th>
                <td>
                  <div class="inner_td">
                    <!-- <input
                      type="number"
                      class="w_55"
                      v-model="setting.inTime"
                      @input="checkNegative_in(setting)"
                    />분 -->
                    <select v-model="setting.inTime">
                      <option :value="0">0분</option>
                      <option :value="10">10분</option>
                      <option :value="15">15분</option>
                      <option :value="20">20분</option>
                    </select>
                    <div class="validation text_green">
                      ※ 회의실이 비었을 경우, 설정한 시간에 맞춰 미리 입실을
                      허용합니다.
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>예약 시작시간 이후</th>
                <td>
                  <div class="inner_td">
                    <!-- <input
                      type="number"
                      class="w_55"
                      v-model="setting.lateInTime"
                      @input="checkNegative_late(setting)"
                    />분 -->
                    <select v-model="setting.lateInTime">
                      <option :value="10">10분</option>
                      <option :value="15">15분</option>
                      <option :value="20">20분</option>
                    </select>
                    <div class="validation text_green">
                      ※ 예약 시작 시간 이후에 설정한 시간까지 입실을 허용합니다.
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>적용대상</th>
                <td>
                  <div class="inner_boxs workplace">
                    <div class="inner_box_column">
                      <div class="checks innerbox_title">
                        <input
                          type="checkbox"
                          :id="'Workplace' + setting.id"
                          v-model="setting.allLocations"
                          @change="checkAllLocations(index)"
                        />
                        <label :for="'Workplace' + setting.id">
                          모든 사업장</label
                        >
                      </div>
                      <div v-show="!setting.allLocations" class="tagbox">
                        <button @click="showModal(index)">+사업장추가</button>
                        <ul class="attendee_add group_choice tags">
                          <li
                            v-for="(
                              location, locIndex
                            ) in setting.workplaceNames"
                            :key="locIndex"
                          >
                            <div>
                              <span>{{ location }}</span>
                            </div>
                            <a
                              @click="removeLocation(index, locIndex)"
                              style="cursor: pointer"
                              >⨉</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="btn_bottom_a">
            <a href="###" @click.prevent="addSetting">+허용설정추가</a>
            <a href="###" class="on" @click.prevent="saveSettings">저장</a>
          </div>
        </article>
      </div>
    </div>
  </div>
  <!-- 사업장 선택 modal -->
  <div
    id="Modal2"
    class="d_pop"
    :style="{ display: isModal2Visible ? 'block' : 'none' }"
    v-if="isModal2Visible"
  >
    <div class="d_pop_box">
      <div class="d_pop_top">
        <div class="title">사업장 선택</div>
        <a @click="hideModal">⨉</a>
      </div>
      <div class="d_pop_middle">
        <div class="tbl_search seach_mobile">
          <table>
            <colgroup>
              <col style="width: 25%" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th>키워드 검색</th>
                <td>
                  <div class="inner_td">
                    <input
                      type="text"
                      class="w_200"
                      placeholder="사업장명을 입력해주세요"
                      v-model="SearchKey"
                      @keyup.enter="searchWorkplace"
                    />
                    <button type="button" @click="searchWorkplace">검색</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tbl_list">
          <table>
            <colgroup>
              <col style="width: 10%" />
              <col />
              <col style="width: 19%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="checkSelectAll"
                  />
                </th>
                <th>사업장명</th>
                <th>선택</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="workplace in paginatedWorkplaces"
                :key="workplace.workplaceId"
                :class="{ disabled: isWorkplaceDisabled(workplace) }"
              >
                <td>
                  <input
                    type="checkbox"
                    v-model="workplace.selected"
                    :disabled="isWorkplaceDisabled(workplace)"
                  />
                </td>
                <td>{{ workplace.workplaceName }}</td>
                <td>
                  <button
                    @click="selectWorkplace(workplace)"
                    class="keep"
                    :disabled="isWorkplaceDisabled(workplace)"
                  >
                    선택
                  </button>
                </td>
              </tr>
              <!-- <tr v-for="workplace in paginatedWorkplaces" :key="workplace.workplaceId">
                <td><input type="checkbox" v-model="workplace.selected"/></td>
                <td>{{ workplace.workplaceName }}</td>
                <td>
                  <button @click="selectWorkplace(workplace)" class="keep">
                    선택
                  </button>
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>
        <!--Paging-->
        <div class="page_num">
          <div class="pageing">
            <a
              href="###"
              v-if="hasPrevPageGroup"
              @click.prevent="prevPageGroup"
            >
              <img src="@/images/front_n.png" alt="처음페이지" />
            </a>
            <a href="###" v-if="hasPrevPage" @click.prevent="prevPage"
              ><img src="@/images/prev_n.png" alt="이전페이지"
            /></a>
            <a
              v-for="page in pageGroup"
              :key="page"
              href="###"
              :class="{ on: currentPage === page }"
              @click.prevent="goToPage(page)"
            >
              {{ page }}
            </a>
            <a href="###" v-if="hasNextPage" @click.prevent="nextPage"
              ><img src="@/images/next_n.png" alt="다음페이지"
            /></a>
            <a href="###" v-if="hasNextPageGroup" @click.prevent="nextPageGroup"
              ><img src="@/images/end_n.png" alt="마지막페이지"
            /></a>
          </div>
        </div>
        <!--//Paging-->
      </div>
      <div class="d_pop_btn">
        <button type="button" class="on" @click="confirmSelection">
          선택완료
        </button>
        <button type="button" @click="hideModal">취소</button>
      </div>
    </div>
  </div>
  <!-- //사업장 선택 modal -->
</template>

<script>
import apiClient from "@/apiClient"; // 설정 파일에서 가져온 axios 인스턴스
import { useToast } from "vue-toastification"; 

export default {
  name: "SettingMeetingroomAccessControl",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      settings: [], // API 로부터 가져온 데이터 설정묶음
      workplaceId: "", // 사업장 아이디 선택값
      isModal2Visible: false, // 모달 표시 상태
      workplaces: [], // 모달에 표시할 사업장 목록
      selectedSettingIndex: null, // 현재 선택된 설정의 인덱스
      selectAll: false, // 전체 선택 체크박스 상태
      totalWorkplaces: 0, // 총 사업장 수
      SearchKey: "", // 검색 키워드
      pageGroupSize: 3, // 하단 페이지 나오는 수 ( 1-5 / 6-10 > 5개씩 )
      currentPage: 1, // 현재 페이지
      itemsPerPage: 10, // 페이지 당 항목 수
    };
  },
  mounted() {
    this.loadSettings();
    this.loadWorkplaces();
  },
  computed: {
    // 총 페이지 수 계산
    totalPages() {
      return Math.ceil(this.totalWorkplaces / this.itemsPerPage);
    },
    // 현재 페이지에 해당하는 사업장 목록을 반환
    paginatedWorkplaces() {
      if (!Array.isArray(this.workplaces)) {
        return [];
      }

      const start = 0;
      const end = this.itemsPerPage;
      console.log("Paginated Workplaces: ", this.workplaces.slice(start, end));

      return this.workplaces.slice(start, end);
    },

    // 현재 페이지 그룹 계산
    pageGroup() {
      const start =
        Math.floor((this.currentPage - 1) / this.pageGroupSize) *
          this.pageGroupSize +
        1;
      const end = Math.min(start + this.pageGroupSize - 1, this.totalPages);
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    hasPrevPageGroup() {
      return this.currentPage > 1;
    },
    hasNextPageGroup() {
      return this.currentPage < this.totalPages;
    },
    hasPrevPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    isAnyAllLocationsChecked() {
      return this.settings.some((setting) => setting.allLocations);
    },
  },
  methods: {
    checkNegative_in(setting) {
      if (setting.inTime < 0) {
		    this.toast.error("0 이상의 숫자를 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        setting.inTime = 0; // 음수 값을 0으로 변경
      }

      if (setting.inTime > 10) {
		    this.toast.error("10 이상의 숫자는 설정 불가능 합니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        setting.inTime = 10; // 음수 값을 0으로 변경
      }
    },
    checkNegative_res(setting) {
      if (setting.resAvailableTime < 0) {
		    this.toast.error("0 이상의 숫자를 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        setting.resAvailableTime = 0; // 음수 값을 0으로 변경
      }
      if (setting.resAvailableTime > 10) {	
		    this.toast.error("10 이상의 숫자는 설정 불가능 합니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        setting.resAvailableTime = 10; // 음수 값을 0으로 변경
      }
    },
    checkNegative_late(setting) {
      if (setting.lateInTime < 0) {
		    this.toast.error("0 이상의 숫자를 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        setting.lateInTime = 0; // 음수 값을 0으로 변경
      }
      if (setting.lateInTime > 10) {
		    this.toast.error("10 이상의 숫자는 설정 불가능 합니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        setting.lateInTime = 10; // 음수 값을 0으로 변경
      }
    },
    // 사업장이 비활성화되어야 하는지 확인
    isWorkplaceDisabled(workplace) {
      return (
        workplace.disabled ||
        this.settings.some((setting) =>
          setting.workplaceIds.includes(workplace.workplaceId)
        )
      );
    },
    async loadSettings() {
      try {
        const searchParam = {
          LoginId: localStorage.getItem("userid"),
          CompanyId: localStorage.getItem("companyid"),
        };
        const response = await apiClient.post(
          "/api/IntimeSetting/intime-setting-list",
          searchParam
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          console.log(data);
          this.settings = data.data.map((item) => ({
            id: Date.now() + Math.random(), // 고유 ID 생성
            companyId: item.companyId,
            packageNum: item.packageNum,
            workplaceIds: item.workplaceId.split("^"),
            workplaceNames: item.workPlaceName.split("^"),
            inTime: item.inTime,
            resAvailableTime: item.resAvailableTime,
            lateInTime: item.lateInTime,
            inTimeApprovalYN: item.inTimeApprovalYN === "Y",
            allLocations: false,
          }));
        }
      } catch (error) {
        console.error("Error loading companies:", error);
      }
    },
    async loadWorkplaces() {
      try {
        const searchParam = {
          SearchType: "workplaceName",
          SearchKey: this.SearchKey,
          PageSize: this.itemsPerPage,
          Page: this.currentPage,
          CompanyId: localStorage.getItem("companyid"),
        };
        const response = await apiClient.post(
          "/api/Workplace/all-workplace-list",
          searchParam
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.workplaces = Array.isArray(data.data) ? data.data : [];
          this.totalWorkplaces = data.meta.totalCount || 0;
        }
      } catch (error) {
        console.error("Error loading companies:", error);
      }
    },
    addSetting() {
      if (this.settings.length >= 10) {	
		    this.toast.error("최대 10개의 허용설정만 추가할 수 있습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
      } else {
        const newPackageNum =
          this.settings.length > 0
            ? Math.max(...this.settings.map((s) => parseInt(s.packageNum))) + 1
            : 1;

        this.settings.push({
          id: Date.now() + Math.random(), // 고유 ID 생성
          companyId: localStorage.getItem("companyid"),
          packageNum: newPackageNum.toString(),
          workplaceIds: [],
          workplaceNames: [],
          inTime: 0,
          resAvailableTime: 0,
          lateInTime: 0,
          inTimeApprovalYN: false,
          allLocations: false,
        });

        // packageNum을 기준으로 정렬하여 번호가 순서대로 유지되도록 합니다.
        this.settings.sort((a, b) => a.packageNum - b.packageNum);
      }
    },
    showModal(index) {
      this.selectedSettingIndex = index;
      this.updateWorkplacesDisabledState();
      this.isModal2Visible = true;
    },
    // 비활성화 상태 업데이트
    updateWorkplacesDisabledState() {
      const disabledWorkplaceIds = new Set(
        this.settings.flatMap((setting) => setting.workplaceIds)
      );

      // 모든 사업장 비활성화 상태 업데이트
      this.workplaces.forEach((workplace) => {
        workplace.disabled = disabledWorkplaceIds.has(workplace.workplaceId);
      });
    },
    hideModal() {
      this.isModal2Visible = false;
      this.workplaces.forEach((workplace) => {
        delete workplace.disabled; // 비활성화 상태 제거
      });
    },
    selectWorkplace(workplace) {
      const setting = this.settings[this.selectedSettingIndex];

      if (setting.workplaceIds.includes(workplace.workplaceId)) {
		    this.toast.error("이미 허용설정 선택된 사업장입니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return;
      }

      setting.workplaceIds.push(workplace.workplaceId);
      setting.workplaceNames.push(workplace.workplaceName);

      this.hideModal();
    },
    confirmSelection() {
      const selectedWorkplaces = this.workplaces.filter(
        (workplace) => workplace.selected
      );
      if (selectedWorkplaces.length === 0) {
		    this.toast.error("사업장을 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return;
      }

      selectedWorkplaces.forEach((workplace) => {
        this.selectWorkplace(workplace);
      });

      this.hideModal();
    },
    removeSetting(index) {
      if (this.settings.length === 1) {	
		    this.toast.error("최소 하나의 허용설정은 필요합니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
      } else {
        this.settings.splice(index, 1);
      }
    },
    removeLocation(settingIndex, locIndex) {
      const confirmed = confirm("삭제하시겠습니까?");
      if (confirmed) {
        this.settings[settingIndex].workplaceIds.splice(locIndex, 1);
        this.settings[settingIndex].workplaceNames.splice(locIndex, 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadWorkplaces(); // 페이지가 변경될 때마다 데이터 다시 가져오기
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadWorkplaces(); // 페이지가 변경될 때마다 데이터 다시 가져오기
      }
    },
    nextPageGroup() {
      if (this.hasNextPageGroup) {
        this.currentPage = this.pageGroup[this.pageGroup.length - 1] + 1;
        this.loadWorkplaces(); // 페이지가 변경될 때마다 데이터 다시 가져오기
      }
    },
    prevPageGroup() {
      if (this.hasPrevPageGroup) {
        this.currentPage = this.pageGroup[0] - 1;
        this.loadWorkplaces(); // 페이지가 변경될 때마다 데이터 다시 가져오기
      }
    },
    async searchWorkplace() {
      this.currentPage = 1;
      this.workplaces = []; // 페이지 변경 시 목록 초기화
      this.loadWorkplaces();
    },
    goToPage(page) {
      this.currentPage = page;
      this.workplaces = []; // 페이지 변경 시 목록 초기화
      this.loadWorkplaces();
    },
    handleItemsPerPageChange() {
      this.currentPage = 1; // itemsPerPage 변경 시 페이지를 1로 리셋
      this.workplaces = []; // 페이지 변경 시 목록 초기화
      this.loadWorkplaces();
    },
    handleSearchKeyEnter() {
      this.currentPage = 1; // itemsPerPage 변경 시 페이지를 1로 리셋
      this.workplaces = []; // 페이지 변경 시 목록 초기화
      this.loadWorkplaces();
    },
    checkSelectAll() {
      const selectAllState = this.selectAll;
      this.workplaces.forEach((workplace) => {
        workplace.selected = selectAllState;
      });
    },
    checkAllLocations(index) {
      if (this.settings[index].allLocations) {
        const confirmed = confirm(
          "모든 사업장이 선택되면 다른 허용설정은 초기화됩니다. 진행하시겠습니까?"
        );
        if (confirmed) {
          this.settings = this.settings.filter((_, i) => i === index);
        } else {
          // 확인을 누르지 않았을 경우 체크를 해제합니다.
          this.settings[index].allLocations = false;
        }
      } else {
        this.settings[index].workplaceIds = [];
        this.settings[index].workplaceNames = [];
      }
    },
    async saveSettings() {
      // 빈 설정 확인
      const emptySettings = this.settings.filter(
        (setting) => !setting.allLocations && setting.workplaceIds.length === 0
      );

      // 빈 설정이 있는 경우 경고 메시지 표시
      if (emptySettings.length > 0) {
		    this.toast.error("설정을 하지 않은 허용설정 부분이 있습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return;
      }

      // 모든 사업장이 선택되지 않은 경우 경고 표시
      const totalSelectedWorkplaces = this.settings.reduce((acc, setting) => {
        if (setting.allLocations) {
          return acc + this.totalWorkplaces; // 모든 사업장이 선택된 것으로 간주
        } else {
          return acc + setting.workplaceIds.length;
        }
      }, 0);

      if (totalSelectedWorkplaces < this.totalWorkplaces) {
		    this.toast.error("선택되지 않은 사업장이 있습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return;
      }

      // 빈 설정을 제외하고 서버로 설정 값을 전송
      const payload = this.settings
        .filter(
          (setting) => setting.allLocations || setting.workplaceIds.length > 0
        ) // 빈 설정을 제외
        .map((setting) => ({
          companyId: setting.companyId,
          packageNum: setting.allLocations ? "1" : setting.packageNum, // '모든 사업장' 체크된 경우 packageNum을 1로 설정
          workplaceIds: setting.allLocations
            ? this.workplaces
                .map((workplace) => workplace.workplaceId)
                .join("^") // 모든 사업장 ID를 추가
            : setting.workplaceIds.join("^"),
          inTime: setting.inTime.toString(),
          resAvailableTime: setting.resAvailableTime.toString(),
          lateInTime: setting.lateInTime.toString(),
          inTimeApprovalYN: setting.inTimeApprovalYN ? "Y" : "N",
        }));

      console.log(payload);

      try {
        // 각 payload 요소에 대해 API 호출
        const savePromises = payload.map(async (data) => {
          const response = await apiClient.post(
            "/api/IntimeSetting/intime-setting-save",
            {
              CompanyId: data.companyId,
              PackageNum: data.packageNum,
              WorkplaceId: data.workplaceIds,
              InTime: data.inTime,
              ResAvailableTime: data.resAvailableTime,
              LateInTime: data.lateInTime,
              InTimeApprovalYN: data.inTimeApprovalYN,
              LoginId: localStorage.getItem("userid"),
            }
          );

          if (response.status !== 200) {
            throw new Error(
              "Error saving settings for packageNum: " + data.packageNum
            );
          }

          return response.data;
        });

        // 모든 API 호출이 완료될 때까지 기다림
        await Promise.all(savePromises);
		    this.toast.success("상세 출입 설정 정보가 성공적으로 저장되었습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
      } catch (error) {
        console.error("Error saving intime data:", error);
		    this.toast.error("상세 출입 설정 정보가 저장 중 오류가 발생했습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
      }
    },
  },
};
</script>

<style scoped>
.warning_message {
  color: red;
  font-weight: bold;
  margin-bottom: 10px;
}

/* 비활성화된 항목의 스타일 */
.disabled {
  background-color: #f5f5f5;
  color: #b0b0b0;
  cursor: not-allowed;
}

.disabled input,
.disabled button {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
